import React from "react";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import './Resume.css'

function Resume_Education() {
  const isSmallScreen = window.innerWidth <= 300;

  return (
    <>
      <Card className={"resume-card"}>
        <h1 className={"resume-card-title"}>Educations</h1> <br></br>
        <Row>
          {/* First column (Year) */}
          <Col xs={isSmallScreen ? 4 : 2} className="text-center res-year">

            <Row>
              <p> 2023.02 </p>
            </Row>

            <Row>
              <p> 2019.03 ~ 2023.02 </p>
            </Row>

            <Row>
              <p> 2018.03 ~ 2019.02 </p>
            </Row>

          </Col>
          {/* Second column (Vertical line) */}
          <Col xs={1} className="text-center">
            <div className="vertical-line"></div>
          </Col>
          {/* Third column (University graduation) */}
          <Col xs={isSmallScreen ? 6 : 8} className="text-center res-edu-text">
            <Row>
              <p> Bachelor of Engineering, Bachelor of Business Administration at Sookmyung Women's University </p> <br></br>
            </Row>
            <Row>
              <p> Major in Software Convergence (Primary Major), Double Major in Business Administration at Sookmyung Women's University </p> <br></br>
            </Row>
            <Row>
              <p> Admission to the Basic Engineering Department at Sookmyung Women's University (Self-designed Major in Engineering College) </p>
            </Row>
          </Col>
        </Row>
        <br></br>

        <h1 className={"resume-card-title"}>Completions</h1> <br></br>
        <Row>
          {/* First column (Year) */}
          <Col  xs={isSmallScreen ? 4 : 3} className="text-center res-year">

            <Row>
              <p> 2021.06 ~ 2021.07 </p>
            </Row>

            <Row>
              <p> 2021.06 </p>
            </Row>

            <Row>
              <p> 2021.02 ~ 2021.03 </p>
            </Row>

            <Row>
              <p> 2021.09 ~ 2021.12 </p>
            </Row>

            <Row>
              <p> 2021.05 </p>
            </Row>
          </Col>

          {/* Second column (Vertical line) */}
          <Col xs={1} className="text-center">
            <div className="vertical-line"></div>
          </Col>
          {/* Third column (Certificates) */}
          <Col  xs={isSmallScreen ? 6 : 8} className="text-center res-edu-text">
            <Row>
              <p> Completed Basic Competency Education for Public Data Youth Internship Program at Korea Intelligent Society Information Institute </p> <br></br>
            </Row>
            <Row>
              <p> Completed Comparison Project of IoT and AI Device Development at Sookmyung Women's University </p> <br></br>
            </Row>
            <Row>
              <p> Completed Web Publishing Course at Codeit </p>
            </Row>
            <Row>
              <p> Completed DevelUP Course at Cloudike </p>
            </Row>
            <Row>
              <p> Completed AWS Cloud Education </p>
            </Row>
          </Col>
        </Row>
      </Card>
    </>
  );
}

export default Resume_Education;
